import React, { useState, useEffect } from "react";
import dayjs from 'dayjs';
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import "flatpickr/dist/themes/material_green.css";
import flatpickr from "flatpickr";
import { useDispatch, useSelector } from "react-redux";
import { leadsData } from "../../../core/data/json/leads";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DefaultEditor from "react-simple-wysiwyg";
import {
  setActivityTogglePopup,
  setActivityTogglePopupTwo,
} from "../../../core/data/redux/commonSlice";
import {
  activeList,
  initialSettings,
  options1,
  priorityList,
} from "../../../core/common/selectoption/selectoption";
import Select from "react-select";
import DatePicker from "react-datepicker";
import CollapseHeader from "../../../core/common/collapse-header";
import { SelectWithImage2 } from "../../../core/common/selectWithImage2";
import { Modal } from 'react-bootstrap';
import { all_routes } from "../../router/all_routes";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { createLogCall, deleteLogCall, viewMemberLogCall, updateLogCall, userList, detailLogCall, updateLogCallStatus, listLeadsOption, listContactsOptionn, listAccountsOption, listOpportunitiesOption } from "../leads/logcall_api";
import { accountType, ascendingandDecending, documentType, LocaleData, selectRelatedToType, selectAssignType, statusList, selectTaskCategoryOptions, selectTaskStatusOptions, selectTaskPriorityOptions } from "../../../core/common/selectoption/selectoption";
import { createTask, deleteTask, viewMemberTasks, updateTask, detailTask, getAllTasks } from "./task_api";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { useNavigate } from "react-router-dom";
import { label } from "yet-another-react-lightbox/*";
import ResponseModal from "../../../core/modals/response_modal";
interface Lead {
  id: number;
  uuid?: string;
  salutation: string;
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
  mobile?: string;
  rating?: string;
  owner?: string;
  tags?: Array<{
    tagId: number;
    name: string;
  }>;
  title?: string;
  leadSource?: string;
  leadStatus?: string;
  priority?: string;
  description?: string;
  language?: string;
  company?: string;
  industry?: string;
  website?: string;
  noOfEmployees?: string;
  street?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  facebook?: string;
  skype?: string;
  linkedin?: string;
  twitter?: string;
  instagram?: string;
  whatsapp?: string;
  campaignHistory?: Array<{
    campaignId: string;
    campaignName: string;
    startDate: string;
    endDate: string;
    type: string;
    status: string;
  }>;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  visibility: string;
}
interface Tasks {
  id: number;
  uuid: string;
  title: string;
  category: string;
  status: string;
  priority: string;
  description?: string
  startDate: string;
  endDate: string;
  responsible: { uuid: string; username: string };
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
}
interface CreateTaskDTO {
  memberId: number;
  title: string;
  category: string;
  responsible: string;
  startDate: string;
  endDate?: string;
  status: string;
  priority: string;
  description?: string;
  assignType: string;
  assignId: number;
  targetType: string;
  targetId: number;
}
interface UpdateTaskDTO {
  memberId: number;
  title: string;
  category: string;
  responsible: string;
  startDate: string;
  endDate?: string;
  status: string;
  priority: string;
  description?: string;
  assignType: string;
  assignId: number;
  targetType: string;
  targetId: number;
}
interface TaskDetailDTO {
  title: string;
  category: string;
  responsible: { uuid: string; username: string }
  startDate: string;
  endDate: string;
  assignTags: Array<{ id: number; uuid: string; name: string }>;
  priority: string;
  status: string;
  description: string;
  targetType: string;
  targets: { id: number; name: string };
  assignType: string;
  assignee: { id: number; name: string };
}
interface ContactlListDTO {
  contactId: number;
  contactName: string;
}
interface OpportunityListDTO {
  id: number;
  name: string;
}
interface CampaignListDTO {
  campaignId: number;
  campaignName: string;
}
interface AccountListDTO {
  accountId: number;
  accountName: string;
}
interface LeadListDTO {
  leadId: number;
  leadUuid: string;
  leadName: string;
  company: string;
  phone: string;
  email: string;
  leadStageId: number;
  leadStatus: string;
  createdDate: string;
  leadOwner: string;
}
interface UserCall {
  id: number;
  uuid: string;
  username: string;
  role: string;
}

const route = all_routes;

const getCategoryIcon = (category: string) => {
  switch (category.toLowerCase()) {
    case 'calls':
      return 'ti ti-phone';
    case 'follow-up':
      return 'ti ti-refresh';
    case 'email':
      return 'ti ti-mail';
    case 'meeting':
      return 'ti ti-calendar';
    case 'other':
      return 'ti ti-dots';
    default:
      return 'ti ti-dots';
  }
};

const getCategoryColor = (category: string) => {
  switch (category.toLowerCase()) {
    case 'calls':
      return 'bg-primary';
    case 'follow-up':
      return 'bg-info';
    case 'email':
      return 'bg-success';
    case 'meeting':
      return 'bg-warning';
    case 'other':
      return 'bg-secondary';
    default:
      return 'bg-secondary';
  }
};

const getStatusColor = (status: string) => {
  switch (status.toLowerCase()) {
    case 'not-start':
      return 'bg-dark';
    case 'pending':
      return 'bg-warning';
    case 'in-progress':
      return 'bg-info';
    case 'completed':
      return 'bg-success';
    case 'overdue':
      return 'bg-danger';
    default:
      return 'bg-dark';
  }
};
const getPriorityColor = (priority: string) => {
  switch (priority.toLowerCase()) {
    case 'low':
      return 'badge-green-light';
    case 'medium':
      return 'badge-yellow-light';
    case 'high':
      return 'badge-red-light';
    default:
      return 'badge-gray-light';
  }
};

const Task = () => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [show3, setShow3] = useState(false);
  const [selectedTaskResponsible, setSelectedTaskResponsible] = useState("");
  const [lead, setLead] = useState<Lead | null>(null);
  const [selectedTaskId, setSelectedTaskId] = useState<{ id: number } | null>(null);
  const [editingTask, setEditingTask] = useState<TaskDetailDTO | null>(null);
  const [listLeadAssignType, setListLeadAssignType] = useState<LeadListDTO[]>([]);
  const [listContactAssignType, setListContactAssignType] = useState<ContactlListDTO[]>([]);
  const [listAccountRelatedToType, setListAccountRelatedToType] = useState<AccountListDTO[]>([]);
  const [listOpportunitiesRelatedToType, setListOpportunitiesRelatedToType] = useState<OpportunityListDTO[]>([]);
  const [tasks, setTasks] = useState<Tasks[]>([]);
  const [assignTaskType, setAssignTaskType] = useState("");
  const [relatedTaskType, setSelectRelatedTaskType] = useState("");
  const [assignTaskOptions, setAssignTaskOptions] = useState<{ value: number; label: string }[]>([]);
  const [relateTaskOptions, setRelateTaskOptions] = useState<{ value: number; label: string }[]>([]);
  const [selectedTaskAssignOption, setSelectedTaskAssignOption] = useState<{ value: number; label: string } | null>(null);
  const [selectedTaskRelateOption, setSelectedTaskRelateOption] = useState<{ value: number; label: string } | null>(null);
  const [listUserCall, setListUserCall] = useState<UserCall[]>([]);
  const [taskToDelete, setTaskToDelete] = useState<{ id: number } | null>(null);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [response, setResponse] = useState<{ status: "success" | "error"; message: string } | null>(null);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleDeleteClickTask = (id: number) => {
    setTaskToDelete({ id });
  };
  const handleConfirmDeleteTask = async () => {
    if (!taskToDelete) return;
    console.log(taskToDelete)
    try {
      const response = await deleteTask(taskToDelete.id);
      if (response.status === 200) {
        console.log("Log call deleted successfully");
        setResponse({ status: "success", message: "Task deleted successfully!" });
        setTasks((prevTask) =>
          prevTask.filter((taskToDelete) => taskToDelete.id !== taskToDelete.id)
        );
        fetchTasks();
      }
    } catch (err) {
      console.error("Error deleting task", err);
      setResponse({ status: "error", message: "Task deleted failed!" });
    }
    finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  const fetchListLeadAssignType = async () => {
    try {
      const response = await listLeadsOption();
      setListLeadAssignType(response.data.data || []);
    } catch (err) {
      console.error("Error fetching leads: ", err);
      setError("Failed to load leads.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchListLeadAssignType();
  }, []);
  const fetchListContactAssignType = async () => {
    try {
      const response = await listContactsOptionn();
      setListContactAssignType(response.data.data || []);
    } catch (err) {
      console.error("Error fetching contacts: ", err);
      setError("Failed to load contacts.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchListContactAssignType();
  }, []);
  const fetchAccountRelatedToType = async () => {
    try {
      const response = await listAccountsOption();
      setListAccountRelatedToType(response.data.data || []);
    } catch (err) {
      console.error("Error fetching accounts: ", err);
      setError("Failed to load accounts.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAccountRelatedToType();
  }, []);
  const fetchListOpportunitiesRelatedToType = async () => {
    try {
      const response = await listOpportunitiesOption();
      console.log("Opportunities datas: ", response.data.data)
      setListOpportunitiesRelatedToType(response.data.data || []);
    } catch (err) {
      console.error("Error fetching opportunities: ", err);
      setError("Failed to load opportunities.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchListOpportunitiesRelatedToType();
  }, []);
  const fetchUserCallList = async () => {
    try {
      const userTenantId = Number(localStorage.getItem("userTenantId"));
      console.log("UserTenantIDabcabc: ", userTenantId)
      const response = await userList(userTenantId);
      setListUserCall(response.data.data || []);
    } catch (err) {
      console.error("Error fetching log calls:", err);
      setError("Failed to load log calls.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUserCallList();
  }, []);
  const handleEditClickTask = (id: number) => {
    console.log(id, "asdad");
    setSelectedTaskId({ id });
    fetchSelectedTask(id);
  }
  const handleSelectChange = (e: any, field: string) => {
    setEditingTask((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        [field]: e?.target ? e.target.value : e.value
      };
    });
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setNewTaskData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setEditTaskData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleUpdateTaskInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setEditingTask((prevData) => {
      if (!prevData) return prevData;
      if (name === "responsible") {
        const selectedUser = listUserCall.find(user => user.uuid === value);
        return {
          ...prevData,
          responsible: selectedUser ? { uuid: selectedUser.uuid, username: selectedUser.username } : prevData.responsible
        };
      }
      return {
        ...prevData,
        [name]: name === "memberId" || name === "assignId" || name === "targetId" ? Number(value) || 0 : value,
      };
    });
  };

  const handleUpdateTaskSelectChange = (name: string, value: string | number) => {
    setEditingTask((prevData) => {
      if (!prevData) return prevData;
      if (name === "assignId") {
        return {
          ...prevData,
          assignee: {
            ...prevData.assignee,
            id: value as number,
          },
        };
      }

      if (name === "targetId") {
        return {
          ...prevData,
          targets: {
            ...prevData.targets,
            id: value as number,
          },
        };
      }
      return {
        ...prevData,
        [name]: value,
      };
    });

  };
  const [newTaskData, setNewTaskData] = useState({
    title: "",
    category: "",
    responsible: "",
    startDate: "",
    endDate: "",
    status: "",
    priority: "",
    description: "",
    assignType: "",
    assignId: 0,
    targetType: "",
    targetId: 0,
  });

  const [editTaskData, setEditTaskData] = useState({
    title: "",
    category: "",
    responsible: "",
    startDate: "",
    endDate: "",
    status: "",
    priority: "",
    description: "",
    assignType: "",
    assignId: 0,
    targetType: "",
    targetId: 0,
  });
  const getNewTaskData = (): CreateTaskDTO => {
    return {
      memberId: selectedTaskAssignOption?.value ?? 0,
      title: newTaskData.title,
      category: newTaskData.category,
      responsible: newTaskData.responsible,
      startDate: newTaskData.startDate
        ? new Date(
          new Date(newTaskData.startDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      endDate: newTaskData.endDate
        ? new Date(
          new Date(newTaskData.endDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      status: newTaskData.status,
      priority: newTaskData.priority,
      description: newTaskData.description,
      assignType: newTaskData.assignType,
      assignId: newTaskData.assignId,
      targetType: newTaskData.targetType,
      targetId: newTaskData.targetId,
    };
  };
  const getEditTaskData = (): UpdateTaskDTO => {
    return {
      memberId: selectedTaskAssignOption?.value ?? 0,
      title: editTaskData.title,
      category: editTaskData.category,
      responsible: editTaskData.responsible,
      startDate: editTaskData.startDate
        ? new Date(
          new Date(editTaskData.startDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      endDate: editTaskData.endDate
        ? new Date(
          new Date(editTaskData.endDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      status: editTaskData.status,
      priority: editTaskData.priority,
      description: editTaskData.description,
      assignType: editTaskData.assignType,
      assignId: editTaskData.assignId,
      targetType: editTaskData.targetType,
      targetId: editTaskData.targetId,
    };
  };
  const handleCreateTasks = async () => {
    try {
      const newTask = getNewTaskData();
      const response = await createTask(newTask);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Task created successfully!" });
        resetNewTaskForm();
        fetchTasks();
      }
    } catch (err) {
      console.error("Error creating task:", err);
      setResponse({ status: "error", message: "Task created failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  const handleUpdateTask = async (taskId: number) => {
    try {
      const updatedTask = getEditTaskData();
      const response = await updateTask(taskId, updatedTask);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Task updated successfully!" });
        fetchTasks();
        resetEditTaskForm();
      }
    } catch (err) {
      console.error("Error updating task:", err);
      setResponse({ status: "error", message: "Task updated failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };

  const fetchTasks = async () => {
    try {
      const response = await getAllTasks();
      setTasks(response.data.data || []);
    } catch (err) {
      console.error("Error fetching tasks", err);
      setError("Failed to load tasks.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchTasks();
  }, []);

  // useEffect(() => {
  //   if (newTaskData.assignType === "LEAD") {
  //     setAssignTaskOptions(listLeadAssignType.map(t => ({ value: t.leadId, label: t.leadName })));
  //   } else if (newTaskData.assignType === "CONTACT") {
  //     setAssignTaskOptions(listContactAssignType.map(t => ({ value: t.contactId, label: t.contactName })));
  //   }
  // }, [newTaskData.assignType, listLeadAssignType, listContactAssignType]);
  useEffect(() => {
    const userUuid = localStorage.getItem("userUuid");
    if (userUuid) {
      setNewTaskData(prev => ({
        ...prev,
        responsible: userUuid || ""
      }));
    }
  }, [lead]);
  const handleTaskAssignTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedType = e.target.value;
    let newOptions: { value: number; label: string }[] = [];
    if (selectedType === "LEAD") {
      newOptions = listLeadAssignType.map((t) => ({ value: t.leadId, label: t.leadName }));
    } else if (selectedType === "CONTACT") {
      newOptions = listContactAssignType.map((t) => ({ value: t.contactId, label: t.contactName }));
    }
    setAssignTaskOptions(newOptions);
    setNewTaskData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignId: newOptions[0].value })
    }));
    setEditTaskData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignId: newOptions[0].value })
    }));
  };
  const handleTaskRelatedToTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedType = e.target.value;
    let newOptions: { value: number; label: string }[] = [];
    if (selectedType === "ACCOUNT") {
      newOptions = listAccountRelatedToType.map((t) => ({ value: t.accountId, label: t.accountName }));
    } else if (selectedType === "OPPORTUNITY") {
      newOptions = listOpportunitiesRelatedToType.map((t) => ({ value: t.id, label: t.name }));
    }
    setRelateTaskOptions(newOptions);
    setNewTaskData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetId: newOptions[0].value })
    }));
    setEditTaskData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetId: newOptions[0].value })
    }));

  };
  useEffect(() => {
    setEditTaskData(prev => ({
      ...prev,
      assignRecord: assignTaskOptions.find(opt => opt.value === prev.assignId)?.value || 0
    }));
  }, [assignTaskOptions]);

  useEffect(() => {
    setEditTaskData(prev => ({
      ...prev,
      targetRecord: relateTaskOptions.find(opt => opt.value === prev.targetId)?.value || 0
    }));
  }, [relateTaskOptions]);
  const fetchSelectedTask = async (id: number) => {
    try {
      setSelectedTaskId({ id: id });
      const response = await detailTask(id);
      console.log(response.data.data, "hihihhehehe");
      setEditingTask(response.data.data);
    } catch (err) {
      console.error("Error fetching task.", err);
      setError("Failed to load task.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (editingTask) {
      console.log("Editing Task Data:", editingTask);
      console.log("Assignee:", editingTask.assignee);
      console.log("Targets:", editingTask.targets);
      console.log("Assign Task Options:", assignTaskOptions);
      console.log("Relate Task Options:", relateTaskOptions);

      setEditTaskData({
        title: editingTask.title || "",
        category: editingTask.category || "",
        responsible: editingTask.responsible.uuid || "",
        startDate: editingTask.startDate || "",
        endDate: editingTask.endDate || "",
        status: editingTask.status || "",
        priority: editingTask.priority || "",
        description: editingTask.description || "",
        assignType: editingTask.assignType || "",
        assignId: editingTask.assignee?.id ?? 0,
        targetType: editingTask.targetType || "",
        targetId: editingTask.targets?.id ?? 0,
      });
      if (editingTask.assignee?.id) {
        const selectedAssignOption = assignTaskOptions.find(opt => opt.value === Number(editingTask.assignee.id));
        if (selectedAssignOption) {
          setSelectedTaskAssignOption(selectedAssignOption);
        }
      }
      if (editingTask.targets?.id) {
        const selectedTargetOption = relateTaskOptions.find(opt => opt.value === Number(editingTask.targets.id));
        if (selectedTargetOption) {
          setSelectedTaskRelateOption(selectedTargetOption);
        }
      }
    }
  }, [editingTask, assignTaskOptions, relateTaskOptions]);

  useEffect(() => {
    if (editingTask?.assignType) {
      handleTaskAssignTypeChange({ target: { value: editingTask.assignType } } as React.ChangeEvent<HTMLSelectElement>);
    }
    if (editingTask?.targetType) {
      handleTaskRelatedToTypeChange({ target: { value: editingTask.targetType } } as React.ChangeEvent<HTMLSelectElement>);
    }
  }, [editingTask]);

  const resetNewTaskForm = () => {
    setNewTaskData({
      title: "",
      category: "",
      responsible: "",
      startDate: "",
      endDate: "",
      status: "",
      priority: "",
      description: "",
      assignType: "",
      assignId: 0,
      targetType: "",
      targetId: 0,
    });
  };

  const resetEditTaskForm = () => {
    setEditTaskData({
      title: "",
      category: "",
      responsible: "",
      startDate: "",
      endDate: "",
      status: "",
      priority: "",
      description: "",
      assignType: "",
      assignId: 0,
      targetType: "",
      targetId: 0,
    });
  };



  const dispatch = useDispatch();
  const activityToggle = useSelector(
    (state: any) => state?.activityTogglePopup
  );
  const activityToggleTwo = useSelector(
    (state: any) => state?.activityTogglePopupTwo
  );
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };
  const [selectedDate1, setSelectedDate1] = useState<Date | null>(new Date());
  const handleDateChange1 = (date: Date | null) => {
    setSelectedDate1(date);
  };

  const meetingMode = [
    { value: "Choose", label: "Choose" },
    { value: "Calls", label: "Calls" },
    { value: "Email", label: "Email" },
    { value: "Meeting", label: "Meeting" },
  ];


  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-4">
                    <h4 className="page-title">
                      Tasks<span className="count-title">123</span>
                    </h4>
                  </div>
                  <div className="col-8 text-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="card">
                <div className="card-header">
                  {/* Search */}
                  <div className="row align-items-center">
                    <div className="col-sm-4">
                      <div className="icon-form mb-sm-0">
                        <span className="form-icon">
                          <i className="ti ti-search" />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search Task"
                        />
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end mb-3 mb-sm-0">
                        <Link
                          to="#"
                          className="btn btn-primary"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvas_add"
                        >
                          <i className="ti ti-square-rounded-plus me-2" />
                          Add New Tasks
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* /Search */}
                </div>

                <div className="card-body">
                  <>
                    {/* Filter */}
                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                      <div className="sort-dropdown drop-down task-drops">
                        <Link
                          to="#"
                          className="dropdown-toggle"
                        >
                          All Tasks{" "}
                        </Link>
                      </div>
                      <div className="d-flex align-items-center flex-wrap row-gap-2">
                        <div className="dropdown me-2">
                          <Link
                            to="#"
                            className="dropdown-toggle"
                            data-bs-toggle="dropdown"
                          >
                            <i className="ti ti-sort-ascending-2 me-2" />
                            Sort{" "}
                          </Link>
                          <div className="dropdown-menu  dropdown-menu-start">
                            <ul>
                              <li>
                                <Link
                                  to="#"
                                  className="dropdown-item"
                                >
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Ascending
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="#"
                                  className="dropdown-item"
                                >
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Descending
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="#"
                                  className="dropdown-item"
                                >
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Recently Viewed
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="#"
                                  className="dropdown-item"
                                >
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Recently Added
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="icon-form me-2">
                          <span className="form-icon">
                            <i className="ti ti-calendar" />
                          </span>
                          <DateRangePicker initialSettings={initialSettings}>
                            <input
                              className="form-control bookingrange"
                              type="text"
                            />
                          </DateRangePicker>
                        </div>
                        <div className="form-sorts dropdown">
                          <Link
                            to="#"
                            data-bs-toggle="dropdown"
                            data-bs-auto-close="outside"
                          >
                            <i className="ti ti-filter-share" />
                            Filter
                          </Link>
                          <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-3">
                            <div className="filter-set-view">
                              <div className="filter-set-head">
                                <h4>
                                  <i className="ti ti-filter-share" />
                                  Filter
                                </h4>
                              </div>
                              <div className="accordion" id="accordionExample">
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link
                                      to="#"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseTwo"
                                      aria-expanded="true"
                                      aria-controls="collapseTwo"
                                    >
                                      Task Name
                                    </Link>
                                  </div>
                                  <div
                                    className="filter-set-contents accordion-collapse collapse show"
                                    id="collapseTwo"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Task"
                                        />
                                      </div>
                                      <ul>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input
                                                type="checkbox"
                                                defaultChecked
                                              />
                                              <span className="checkmarks" />
                                              Add a form to Update Task
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Add a form to Update Task
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Update orginal content
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Use only component colours
                                            </label>
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link
                                      to="#"
                                      className="collapsed"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#owner"
                                      aria-expanded="false"
                                      aria-controls="owner"
                                    >
                                      Task Type
                                    </Link>
                                  </div>
                                  <div
                                    className="filter-set-contents accordion-collapse collapse"
                                    id="owner"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Client"
                                        />
                                      </div>
                                      <ul>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input
                                                type="checkbox"
                                                defaultChecked
                                              />
                                              <span className="checkmarks" />
                                              Meeting
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Calls
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Task
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Email
                                            </label>
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link
                                      to="#"
                                      className="collapsed"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseone"
                                      aria-expanded="false"
                                      aria-controls="collapseone"
                                    >
                                      Tags
                                    </Link>
                                  </div>
                                  <div
                                    className="filter-set-contents accordion-collapse collapse"
                                    id="collapseone"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="filter-content-list">
                                      <ul>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input
                                                type="checkbox"
                                                defaultChecked
                                              />
                                              <span className="checkmarks" />
                                              Collab
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Rated
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Promotion
                                            </label>
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link
                                      to="#"
                                      className="collapsed"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseThree"
                                      aria-expanded="false"
                                      aria-controls="collapseThree"
                                    >
                                      Created By
                                    </Link>
                                  </div>
                                  <div
                                    className="filter-set-contents accordion-collapse collapse"
                                    id="collapseThree"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="filter-content-list">
                                      <ul>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input
                                                type="checkbox"
                                                defaultChecked
                                              />
                                              <span className="checkmarks" />
                                              Hendry
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Monty Beer
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Bradtke
                                            </label>
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link
                                      to="#"
                                      className="collapsed"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapsethree"
                                      aria-expanded="false"
                                      aria-controls="collapsethree"
                                    >
                                      Created Date
                                    </Link>
                                  </div>
                                  <div
                                    className="filter-set-contents accordion-collapse collapse"
                                    id="collapsethree"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="filter-content-list">
                                      <ul>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input
                                                type="checkbox"
                                                defaultChecked
                                              />
                                              <span className="checkmarks" />
                                              23 Oct 2023
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              29 Sep 2023
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              24 Oct 2023
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              25 Oct 2023
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                            </label>
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="filter-reset-btns">
                                <div className="row">
                                  <div className="col-6">
                                    <Link to="#" className="btn btn-light">
                                      Reset
                                    </Link>
                                  </div>
                                  <div className="col-6">
                                    <Link
                                      to={route.tasks}
                                      className="btn btn-primary"
                                    >
                                      Filter
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* /Filter */}
                  </>

                  {/* Task List */}
                  <div className="task-wrapper">
                    <div className="tasks-activity tasks">
                      <ul>
                        {tasks.map((task) => (
                          <li key={task.id} className={`task-wrap ${task.status.toLowerCase().replace(' ', '-')}`}>
                            <div className="task-info">
                              <span className="task-icon">
                                <i className="ti ti-grip-vertical" />
                              </span>
                              <div className="set-star rating-select">
                                <i className="fa fa-star" />
                              </div>
                              <p>{task.title}</p>
                              <span className={`badge badge-pill badge-status ${getCategoryColor(task.category)}`}>
                                <i className={getCategoryIcon(task.category)} />
                                {task.category}
                              </span>
                              <span className={`badge badge-tag ${getStatusColor(task.status)}`}>
                                {task.status}
                              </span>
                            </div>
                            <div className="task-actions">
                              <ul>
                                <li className="task-time">
                                  <span className={`badge badge-tag ${getPriorityColor(task.priority)}`}>
                                    {task.priority}
                                  </span>
                                </li>
                                <li className="task-date">
                                  <i className="ti ti-calendar-exclamation" />
                                  {new Date(task.startDate).toLocaleString('vi-VN')} → {new Date(task.endDate).toLocaleString('vi-VN')}
                                </li>
                                <li className="task-owner">
                                  <div className="task-user">
                                    <span className="avatar-text">
                                      {task.responsible.username}
                                    </span>
                                  </div>
                                  <div className="task-actions-inline">
                                    <Link
                                      className="btn btn-sm btn-outline-primary me-2"
                                      data-bs-toggle="offcanvas"
                                      to="#"
                                      data-bs-target="#offcanvas_edit"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleEditClickTask(task.id);
                                      }}
                                    >
                                      <i className="ti ti-edit"></i> Edit
                                    </Link>
                                    <Link
                                      className="btn btn-sm btn-outline-danger"
                                      to="#"
                                      data-bs-toggle="modal"
                                      data-bs-target="#delete_activity"
                                      onClick={() => handleDeleteClickTask(task.id)}
                                    >
                                      <i className="ti ti-trash"></i> Delete
                                    </Link>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <>
        {/* Add New Task */}
        <div
          className="offcanvas offcanvas-end offcanvas-large"
          tabIndex={-1}
          id="offcanvas_add"
        >
          <div className="offcanvas-header border-bottom">
            <h4>Add New Task</h4>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form>
              <div>
                <div className="row">
                  <div className="col-md-12">

                    {/* Member ID */}
                    {/* Title */}
                    <div className="mb-3">
                      <label className="col-form-label">Title <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        value={newTaskData.title}
                        onChange={handleInputChange}
                      />
                    </div>

                    {/* Category */}
                    <div className="mb-3">
                      <label className="col-form-label">Category</label>
                      <Select
                        options={selectTaskCategoryOptions}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        value={newTaskData.category ? { label: newTaskData.category, value: newTaskData.category } : null}
                        onChange={(selectedOption) => setNewTaskData({ ...newTaskData, category: selectedOption?.value || "" })}
                      />
                    </div>

                    {/* Responsible */}
                    <div className="mb-3">
                      <label className="col-form-label">Responsible</label>
                      <select
                        className="form-control"
                        name="responsible"
                        disabled={true}
                        value={newTaskData.responsible}
                        onChange={handleInputChange}
                      >
                        <option value="" disabled>Select Responsible</option>
                        {listUserCall.map((user) => (
                          <option key={user.uuid} value={user.uuid}>
                            {user.username}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* Assign Type */}
                    <div className="row">
                      {/* Assign Type */}
                      <div className="col-md-6">
                        <label className="col-form-label">Assign Type</label>
                        <select
                          className="form-control"
                          value={newTaskData.assignType}
                          onChange={handleTaskAssignTypeChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Assign */}
                      <div className="col-md-6">
                        <label className="col-form-label">Assign</label>
                        <Select
                          className="select2"
                          options={assignTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={assignTaskOptions.find(option => option.value === newTaskData.assignId) || null}
                          onChange={(selectedOption) => setNewTaskData({ ...newTaskData, assignId: selectedOption?.value || 0 })}
                          isDisabled={assignTaskOptions.length === 0}
                        />
                      </div>
                    </div>

                    {/* Target Type */}
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select
                          className="form-control"
                          value={newTaskData.targetType}
                          onChange={handleTaskRelatedToTypeChange}
                        >
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Target */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          className="select2"
                          options={relateTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={relateTaskOptions.find(option => option.value === newTaskData.targetId) || null}
                          onChange={(selectedOption) => setNewTaskData({ ...newTaskData, targetId: selectedOption?.value || 0 })}
                          isDisabled={relateTaskOptions.length === 0}
                        />
                      </div>
                    </div>

                    <div className="row">
                      {/* Start Date */}
                      <div className="mb-6">
                        <label className="col-form-label">Start Date <span className="text-danger">*</span></label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="startDate"
                          value={newTaskData.startDate}
                          onChange={handleInputChange}
                        />
                      </div>

                      {/* End Date */}
                      <div className="mb-6">
                        <label className="col-form-label">End Date</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="endDate"
                          value={newTaskData.endDate}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    {/* Status */}
                    <div className="mb-3">
                      <label className="col-form-label">Status <span className="text-danger">*</span></label>
                      <Select
                        options={selectTaskStatusOptions}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        value={newTaskData.status ? { label: newTaskData.status, value: newTaskData.status } : null}
                        onChange={(selectedOption) => setNewTaskData({ ...newTaskData, status: selectedOption?.value || "" })}
                      />
                    </div>

                    {/* Priority */}
                    <div className="mb-3">
                      <label className="col-form-label">Priority</label>
                      <Select
                        options={selectTaskPriorityOptions}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        value={newTaskData.priority ? { label: newTaskData.priority, value: newTaskData.priority } : null}
                        onChange={(selectedOption) => setNewTaskData({ ...newTaskData, priority: selectedOption?.value || "" })}
                      />
                    </div>

                    {/* Description */}
                    <div className="mb-3">
                      <label className="col-form-label">Description</label>
                      <textarea
                        className="form-control"
                        name="description"
                        rows={4}
                        value={newTaskData.description}
                        onChange={handleInputChange}
                      />
                    </div>

                    {/* Confirm & Cancel Buttons */}
                    <div className="text-end modal-btn">
                      <button className="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                      <button className="btn btn-primary" data-bs-dismiss="modal" type="button" onClick={handleCreateTasks}>
                        Confirm
                      </button>
                    </div>

                  </div>
                </div>
              </div>

            </form>
          </div>
        </div>
        {/* /Add New Task */}
        {/* Edit Task */}
        <div
          className="offcanvas offcanvas-end offcanvas-large"
          tabIndex={-1}
          id="offcanvas_edit"
        >
          <div className="offcanvas-header border-bottom">
            <h4>Edit Task</h4>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form>
              <div className="row">
                <div className="col-md-12">
                  {/* Title */}
                  <div className="mb-3">
                    <label className="col-form-label">Title <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" name="title" value={editingTask?.title || ""} onChange={handleUpdateTaskInputChange} />
                  </div>

                  {/* Category */}
                  <div className="mb-3">
                    <label className="col-form-label">Category</label>
                    <Select
                      options={selectTaskCategoryOptions}
                      placeholder="Choose"
                      name="category"
                      value={selectTaskCategoryOptions.find(opt => opt.value === editingTask?.category)}
                      onChange={(option) => handleUpdateTaskSelectChange("category", option?.value ?? "")}
                      classNamePrefix="react-select"
                    />
                  </div>

                  {/* Responsible */}
                  <div className="mb-3">
                    <label className="col-form-label">Responsible</label>
                    <select className="form-control" name="responsible" disabled={true} value={editingTask?.responsible.uuid || ""} onChange={handleUpdateTaskInputChange}>
                      <option value="" disabled>Select Responsible</option>
                      {listUserCall.map(user => (
                        <option key={user.uuid} value={user.uuid}>{user.username}</option>
                      ))}
                    </select>
                  </div>
                  {/* Assign Type */}
                  <div className="row">
                    <div className="col-md-6">
                      <label className="col-form-label">Assign Type</label>
                      <select className="form-control" name="assignType" disabled={true} value={selectAssignType.find(option => option.value === editingTask?.assignType)?.value || "LEAD"} onChange={handleUpdateTaskInputChange}>
                        <option value="">Select Assign Type</option>
                        {selectAssignType.map(option => (
                          <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                      </select>
                    </div>
                    {/* Assign */}
                    <div className="col-md-6">
                      <label className="col-form-label">Assign</label>
                      <Select
                        options={assignTaskOptions}
                        placeholder="Choose"
                        value={assignTaskOptions.find(opt => opt.value === Number(editingTask?.assignee?.id)) || null}
                        onChange={(option) => handleUpdateTaskSelectChange("assignId", option?.value || 0)}
                        isDisabled={true}
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>

                  {/* Target Type */}
                  <div className="row">
                    <div className="col-md-6">
                      <label className="col-form-label">Target Type</label>
                      <select className="form-control" name="targetType" disabled={true} value={editingTask?.targetType || ""} onChange={handleUpdateTaskInputChange}>
                        <option value="">Select Target Type</option>
                        {selectRelatedToType.map(option => (
                          <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                      </select>
                    </div>

                    {/* Target ID */}
                    <div className="col-md-6">
                      <label className="col-form-label">Target</label>
                      <Select
                        options={relateTaskOptions}
                        placeholder="Choose"
                        value={relateTaskOptions.find(opt => opt.value === editingTask?.targets?.id) || null}
                        onChange={(option) => handleUpdateTaskSelectChange("targetId", option?.value ?? 0)}
                        isDisabled={true}
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>

                  <div className="row">
                    {/* Start Date */}
                    <div className="mb-6">
                      <label className="col-form-label">Start Date <span className="text-danger">*</span></label>
                      <input type="datetime-local" className="form-control" name="startDate" value={editingTask?.startDate || ""} onChange={handleUpdateTaskInputChange} />
                    </div>

                    {/* End Date */}
                    <div className="mb-6">
                      <label className="col-form-label">End Date</label>
                      <input type="datetime-local" className="form-control" name="endDate" value={editingTask?.endDate || ""} onChange={handleUpdateTaskInputChange} />
                    </div>
                  </div>

                  {/* Status */}
                  <div className="mb-3">
                    <label className="col-form-label">Status <span className="text-danger">*</span></label>
                    <Select options={selectTaskStatusOptions}
                      value={selectTaskStatusOptions.find(opt => opt.value === editingTask?.status)}
                      onChange={(option) => handleUpdateTaskSelectChange("status", option?.value || "")} />
                  </div>

                  {/* Priority */}
                  <div className="mb-3">
                    <label className="col-form-label">Priority</label>
                    <Select options={selectTaskPriorityOptions} placeholder="Choose"
                      value={selectTaskPriorityOptions.find(opt => opt.value === editingTask?.priority)}
                      onChange={(option) => handleUpdateTaskSelectChange("priority", option?.value || "")} classNamePrefix="react-select" />
                  </div>

                  {/* Description */}
                  <div className="mb-3">
                    <label className="col-form-label">Description</label>
                    <textarea className="form-control" rows={4} name="description" value={editingTask?.description || ""} onChange={handleUpdateTaskInputChange} />
                  </div>

                  {/* Confirm & Cancel Buttons */}
                  <div className="text-end modal-btn">
                    <button className="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                    <button
                      className="btn btn-primary"
                      data-bs-dismiss="modal"
                      type="button"
                      onClick={() => selectedTaskId?.id && handleUpdateTask(selectedTaskId?.id)}
                    >
                      Confirm
                    </button>
                  </div>

                </div>
              </div>
            </form>
          </div>
        </div>
        {/* /Edit Task */}
        {/* Delete Task */}
        <div className="modal fade" id="delete_activity" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="text-center">
                  <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                    <i className="ti ti-trash-x fs-36 text-danger" />
                  </div>
                  <h4 className="mb-2">Remove Task?</h4>
                  <p className="mb-0">
                    Are you sure you want to remove <br /> task you selected.
                  </p>
                  <div className="d-flex align-items-center justify-content-center mt-4">
                    <Link
                      to="#"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <button
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                      onClick={() => handleConfirmDeleteTask()}
                    >
                      Yes, Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Delete Task */}
        {/* Add New View */}
        <div className="modal custom-modal fade" id="save_view" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New View</h5>
                <button
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <form >
                  <div className="mb-3">
                    <label className="col-form-label">View Name</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="modal-btn text-end">
                    <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                      Cancel
                    </Link>
                    <button type="submit" className="btn btn-danger">
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* /Add New View */}
        <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
      </>

    </>
  );
};

export default Task;
